import React from 'react'
import { Flex } from '@jisr-hr/design-system'
import i18n from 'translations/i18n'
import {
  Info,
  Reason,
  ReassignTask,
  ExpenseClaimItems,
  Assignee,
} from 'components/global/templates/RequestDrawer/components'
import { ReactComponent as CalendarIcon } from '../../icons/calendar.svg'
import { ReactComponent as MoneyIcon } from '../../icons/Money.svg'
import { useRequest } from '../../RequestProvider'
import { requestDateFormat } from '../../helper'

const ExpenseClaimRequestTask = () => {
  const {
    vars: { request },
  } = useRequest()

  return (
    <Flex
      flexCol
      style={{ gap: '16px' }}
    >
      <Info
        details={{
          requested_by: request.employee,
          employee: request.employee,
          status: request.status,
          status_i18n: request.status_i18n,
          created_at: request?.request?.created_time,
          requested_on: request?.request?.created_time,
          type_i18n: request.name,
          payment_date: request?.task_info?.paid_at,
          items: [
            {
              icon: <CalendarIcon />,
              label: i18n.t('approved_date'),
              value: requestDateFormat(request.task_info?.approved_at),
            },
            {
              icon: <MoneyIcon />,
              label: i18n.t('payment_type'),
              value: request.task_info?.payment_details?.payment_type_i18n,
            },
            {
              icon: <MoneyIcon />,
              label: i18n.t('bank_name'),
              value: request.task_info?.payment_details?.bank_name_i18n,
            },
            {
              icon: <MoneyIcon />,
              label: i18n.t('bank_iban'),
              value: request.task_info?.payment_details?.iban,
            },
            {
              icon: <MoneyIcon />,
              label: i18n.t('salary_type'),
              value: request.task_info?.payment_details?.salary_type_i18n,
            },
          ],
        }}
      />
      <ExpenseClaimItems ecrItems={request.task_info?.ecr_items} />
      {(request?.task_info?.reason || request?.task_info?.attachments?.length > 0) && (
        <Reason
          details={{
            reason: request.task_info?.reason,
            attachments: request.task_info?.attachments,
          }}
        />
      )}
      {request?.attachments?.length > 0 && (
        <Reason
          title={i18n.t('attachment_file')}
          details={{ attachments: request.attachments }}
        />
      )}
      {request?.status === 'Pending' && <ReassignTask />}
      <Assignee
        details={{
          assignee: request.assignee,
          status: request.status,
          status_i18n: request.status_i18n,
          time: request?.time,
        }}
      />
    </Flex>
  )
}

export default ExpenseClaimRequestTask
